/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

//@ts-nocheck
import React, { useState } from 'react';
import Card from 'react-bootstrap/Card';
import * as S from './styles';
import { Row, Col, Button } from 'react-bootstrap';
import { SelectableCardContainer } from '@vlinder-web/selectable-card-container-widget-react';
import { useTheme } from '../../../../providers/theme';
export interface IPaymentCompProps {
  paymentMethods?: {
    key?: string;
    title?: string;
    subTitle?: string;
  }[];
  buttonText?: string;
  onPaymentTypeSubmit?(type: string): void;
}
export const PaymentMethod = (props: IPaymentCompProps) => {
  const theme = useTheme();

  const { paymentMethods, buttonText, onPaymentTypeSubmit } = props;
  const [selected, setSelected] = useState<string>();

  const _getPaymentOptions = () => {
    return (
      <>
        {paymentMethods?.map((item: any, index: number) => {
          if (item?.disabled) {
            return (
              <Col xs={12} key={`${item?.key}-${index}`}>
                <Card className="m-2" style={{ backgroundColor: '#ccc' }}>
                  <Card.Body>
                    <S.paymentHeader>{item?.title}</S.paymentHeader>
                    <S.paymentSubHeader>{item?.subTitle}</S.paymentSubHeader>
                    Coming Soon
                  </Card.Body>
                </Card>
              </Col>
            );
          } else {
            return (
              <Col xs={12} key={`${item?.key}-${index}`}>
                <SelectableCardContainer
                  isSelected={item?.key === selected}
                  selectedColor={theme?.colors?.secondary}
                  key={item?.key}
                >
                  <Card onClick={() => setSelected(item?.key)}>
                    <Card.Body>
                      <S.paymentHeader>{item?.title}</S.paymentHeader>
                      <S.paymentSubHeader>{item?.subTitle}</S.paymentSubHeader>
                    </Card.Body>
                  </Card>
                </SelectableCardContainer>
              </Col>
            );
          }
        })}
      </>
    );
  };
  return (
    <>
      <Row className="mt-4">{_getPaymentOptions()}</Row>
      <Button
        onClick={() => onPaymentTypeSubmit && onPaymentTypeSubmit(selected)}
        className="text-dark me-3"
        size="lg"
        style={{ float: 'right' }}
        variant="secondary"
        disabled={!selected}
      >
        {buttonText}
      </Button>
    </>
  );
};
PaymentMethod.defaultProps = {
  paymentMethods: [
    {
      key: 'online',
      title: 'Pay online',
      subTitle: '(By credit card,debit card,wallet)',
    },
    {
      disabled: true,
      key: 'offline',
      title: 'At Insurance Office',
      subTitle: 'Physical visit to Insurance Office',
    },
  ],
  buttonText: 'Next',
};
